<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'SatisModal',
    props:[
        "data",
    ],
    data() {
        return {
            form: {},
            submitted: false,
        };
    }, 
    watch:{
        data(props){
            const { amount, id, subscription_id, main_explaine } = props
            this.form = { amount, id, subscription_id, main_explaine  }
        }
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('satis_modal')
        },
        handleSubmit(){
            this.$http.post(`/members/${this.form.subscription_id}/balances/store?satis=true`, this.form )
                    .then(resp => {
                        notify.success(resp.data.message)
                        this.$emit('loadItems');
                    })
                    .catch(error => error)
        }
    },
};
</script>

<template>
<b-modal id="satis_modal"  title="Satış Ekle"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
       <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="amount">
                <span>Satış</span>
             </label>
            <div class="col">
                <input
                id="amount" 
                v-model="form.amount"
                type="text"
                class="form-control"
                />
          </div>
        </div>
         <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="main_explaine">Açıklama</label>
            <div class="col">
                <input
                id="main_explaine" 
                v-model="form.main_explaine"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Kaydet
            </b-button>
        </div>
    </form>
</b-modal>
</template>